/* eslint-disable no-use-before-define */

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import clickOutside from 'click-outside';
import { createFocusTrap } from 'focus-trap';
import announcer from './aria-announcer';

let unbindClickOutside;
let focusTrap;

const $body = document.querySelector('body');
const $navPrimaryDesktop = document.querySelector('.nav-primary-desktop');
const $menuItems = document.querySelectorAll('.has-submenu');
const $navBtns = document.querySelectorAll('.nav-primary-element');

// Close submenu on escape key
function onEscape(event) {
    if (event.key === 'Escape') {
        $menuItems.forEach((item) => {
            const $button = item.querySelector('button');
            if ($button.getAttribute('aria-expanded') === 'true') {
                closeSubMenu(item);
                window.removeEventListener('keydown', onEscape);
            }
        });
    }
}

function closeSubMenu(item) {
    const $subMenu = item.querySelector('.mega-menu-wrapper');
    const $button = item.querySelector('button');

    $subMenu.inert = true;
    $button.setAttribute('aria-expanded', 'false');

    $subMenu.classList.remove('opened');

    // Check through all the $navBtns if any have aria-expanded="true"
    const anyExpanded = Array.from($navBtns).some((btn) => btn.getAttribute('aria-expanded') === 'true');

    if (!anyExpanded) {
        enableBodyScroll($subMenu);
        focusTrap.deactivate();
        $navPrimaryDesktop.classList.remove('mega-menu-opened');
    }

    // Remove overlay
    $body.classList.remove('with-overlay');

    // clickOutside
    if (unbindClickOutside) {
        unbindClickOutside();
        unbindClickOutside = null;
    }

    // Aria live
    announcer.announce(`Le menu ${$button.textContent} est fermé`);

    // Remove addEventListener on escape key
    window.removeEventListener('keydown', onEscape);
}

function openSubMenu(item) {
    const $subMenu = item.querySelector('.mega-menu-wrapper');
    const $button = item.querySelector('button');

    $subMenu.inert = false;
    $button.setAttribute('aria-expanded', 'true');

    $subMenu.classList.add('opened');

    document.dispatchEvent(new CustomEvent('fadoq:megaMenuOpened'));

    disableBodyScroll($subMenu);

    // Close all other submenus
    $menuItems.forEach((menuItem) => {
        if (menuItem !== item) {
            closeSubMenu(menuItem);
        }
    });

    // Add overlay
    $body.classList.add('with-overlay');
    $navPrimaryDesktop.classList.add('mega-menu-opened');

    // clickOutside
    unbindClickOutside = clickOutside(item, () => {
        closeSubMenu(item);
    });

    setTimeout(() => {
        // Initialize and activate focus trap
        focusTrap = createFocusTrap($subMenu, {
            clickOutsideDeactivates: true,
            preventScroll: true,
        });
        focusTrap.activate();
    }, 100);

    // Aria live
    announcer.announce(`Le menu ${$button.textContent} est ouvert`);

    window.addEventListener('keydown', onEscape);
}

document.addEventListener('fadoq:geolocationPanelOpened', () => {
    $menuItems.forEach((item) => {
        const $button = item.querySelector('button');
        if ($button.getAttribute('aria-expanded') === 'true') {
            closeSubMenu(item);
        }
    });
});

$menuItems.forEach((item) => {
    const $button = item.querySelector('button');
    const $subMenu = item.querySelector('.mega-menu-wrapper');

    // Initialize submenus as inert
    if ($subMenu) {
        $subMenu.inert = true;
    }

    $button.addEventListener('click', (event) => {
        event.stopPropagation();
        if ($button.ariaExpanded === 'false') {
            openSubMenu(item);
        } else {
            closeSubMenu(item);
        }
    });

    // Close button inside submenu
    const $closeBtn = item.querySelector('.btn-close');
    if ($closeBtn) {
        $closeBtn.addEventListener('click', () => {
            closeSubMenu(item);
        });
    }
});
